import styled, { keyframes } from "styled-components";
import { bodyTextBold, bodyTextRegular, linkActionColor } from "../layout/style";
import { breakpoint } from "../layout/style";
const fadeInImage = keyframes`

    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }

`;

export const FigureContainer = styled.figure`
    width: 100%;
    margin: 50px 0px;
    padding: 0px 50px;
    text-align: center;

    & img {
        border-radius: 10px;
        box-shadow: 3px 3px 3px #c0c0c0;
        width: 100%;
        opacity: 0;
        animation: 0.3s ${fadeInImage};
        animation-delay: 0.5s;
        animation-fill-mode: forwards;
        animation-iteration-count: 1;
    }

    & img.no-shadow {
        box-shadow: none;
        border-radius: 0px;
    }

    & video {
        width: 100%;
        max-width: 800px;
        margin: 0px auto;
        border: 1px solid #c0c0c0;
        border-radius: 10px;
    }

    @media ${breakpoint.phone} {
        padding: 0px;
    }
`;

export const FigureCaption = styled.figcaption`
    width: 100%;
    margin: 10px 0px 10px 40px;
    ${bodyTextBold};
    font-size: 16pt;
    text-align: left;
    position: relative;


    &:before {
        position: absolute;
        top: 0px;
        left: -20px;
        content: "↑"
    }

    @media ${breakpoint.phone} {

            font-size: 14pt;
            line-height: 22pt;
            margin: 10px 20px;
        
    }


`;

export const ReadNextSection = styled.div`
    font-size: 16pt;
    text-align: right;
    color: ${linkActionColor};
    cursor: pointer;
    font-weight: 700;

    &:hover {
        text-shadow: 2px 2px 3px #e0e0e0;
        cursor: pointer;
    }

    @media ${breakpoint.phone} {

            font-size: 14pt;
            line-height: 22pt;


    }

`;